import { inAppWebView } from 'Classes/ConfigurationManager';
import { serializeError } from 'serialize-error';

export const postMessage = (options) => {
  if (inAppWebView()) {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refresh_token');
    let data = typeof options === 'object' ? {
      ...options,
      ...token && { token },
      ...refreshToken && { refreshToken }
    } : options;

    // if data is an object and empty, do not send it
    if (typeof data === 'object' && Object.keys(data).length === 0) return;

    data = typeof data === 'object' ? { ...serializeError(data) } : data;
    let mockData = typeof data === 'object' ? { ...serializeError(data) } : data;
    if (mockData.token) mockData.token = '***';
    if (mockData.refreshToken) mockData.refreshToken = '***';
    data = typeof data === 'object' ? JSON.stringify(data) : data;
    mockData = typeof mockData === 'object' ? JSON.stringify(mockData) : mockData;

    const isRN = typeof window.ReactNativeWebView?.postMessage === 'function';
    const isBrowser = typeof window.postMessage === 'function';

    if (isRN) {
      console.info('ReactNativeWebView postMessage', mockData);
      window.ReactNativeWebView.postMessage(data);
    } else if (isBrowser) {
      console.info('Browser postMessage', mockData);
      window.postMessage(data, '*');
    } else {
      console.error('Aucune méthode postMessage disponible');
    }
  }
};

// default {} so in postMessage it's adding token and refreshToken to automatically login in app
export const redirectWebApp = (options = {}) => {
  postMessage(options);
  postMessage('closeWebView');
};

export default {
  computed: {
    isInAppWebView() {
      return inAppWebView();
    },
    isInFacebookApp() {
      const ua = navigator.userAgent || navigator.vendor;
      return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
    },
  },

  methods: {
    postMessage,
    redirectWebApp,
  },
};
